import { render } from "./dropdownHotspot.vue?vue&type=template&id=58a94ec2"
import script from "./dropdownHotspot.vue?vue&type=script&lang=js"
export * from "./dropdownHotspot.vue?vue&type=script&lang=js"

import "./dropdownHotspot.vue?vue&type=style&index=0&id=58a94ec2&lang=scss"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__